<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; padding-left: 50px; font-size: 14px;" :flat='true'>
      <v-chip
        dark
        outlined
        label
        color="#ff810a"
        style="margin-left: -20px; margin-bottom: 6px;"
        @click="openFile()"
      >
          <h3 :style="{color: $mainColor} + 'cursor: pointer;'" @click="openFile()"><b>Программа форума</b></h3>
      </v-chip>
        <!-- <v-row>
          <b class="ml-4" style="padding-left: 10px !important;">Или скачайте сборник в формате PDF:  
            <a href="https://api.kcsni-service.ru/media/rsini/Program_FSNE_26.pdf">Тезисы ФСНЭ 2025.pdf</a></b>
        </v-row> -->
      <p>
        <!-- Подробная программа будет опубликована позднее -->
      </p>
        <p>
        ОСНОВНЫЕ ТЕМАТИЧЕСКИЕ НАПРАВЛЕНИЯ ФОРУМА:
      </p>
      <ul class="custom-list">
        <li>Национальная сеть установок класса «мегасайенс»</li>
        <li>Инфраструктура и аппаратурно-методическое обеспечение синхротронных и нейтронных экспериментов</li>
        <li>Синхротронные и нейтронные методы в материаловедении и индустриальных задачах</li>
        <li>Синхротронные и нейтронные методы в структурной биологии и науках о жизни</li>
        <li>Синхротронные и нейтронные методы в исследовании объектов культурного наследия</li>
        <li>Компактные источники нейтронов в прикладных и фундаментальных задачах</li>
        <li>Методы микроскопии и визуализации структуры вещества</li>
        <li>Времяразрешающие и когерентные методы на источниках синхротронного излучения и рентгеновских лазерах на свободных электронах</li>
        <li>Вычислительные методы, цифровая инфраструктура и технологии искусственного интеллекта в исследованиях на установках класса «мегасайенс»</li>
        <li>Кадровое обеспечение установок класса «мегасайенс»</li>
        
        
        
        
          <!-- <li>Развитие национальной сети установок класса «мегасайенс»</li>
        <li>Современная инфраструктура и аппаратурно-методическое обеспечение синхротронных и нейтронных экспериментов</li>
        <li>Применение синхротронного излучения и нейтронов в материаловедении и индустриальных задачах</li>
        <li>Применение синхротронного излучения и нейтронов в биофизике и науках о жизни</li>
        <li>Синхротронные и нейтронные методы в исследовании объектов культурного наследия</li>
        <li>Развитие и применение современных методов микроскопии и визуализации структуры вещества</li>
        <li>Развитие времяразрешающих и когерентных методов на источниках синхротронного излучения и рентгеновских лазерах на свободных электронах</li>
        <li>Вычислительные методы, цифровая инфраструктура и технологии искусственного интеллекта в исследованиях на установках класса «мегасайенс»</li>
        <li>Подготовка кадров для установок класса «мегасайенс»</li> -->

        <!-- <li><b>Секция 2</b> – Эксперименты In-situ, in-operando, накачка-зондирование</li>
        <li><b>Секция 3</b> – Биологические системы, полимеры, вещество в мягком конденсированном состоянии</li>
        <li><b>Секция 4</b> – Современные задачи экологии, структурной химии, радиохимии</li>
        <li><b>Секция 5</b> – Синхротронная и нейтронная визуализация</li>
        <li><b>Секция 6</b> – Материаловедение и индустриальные задачи</li>
        <li><b>Секция 7</b> – Поверхность, интерфейсы, тонкие пленки</li>
        <li><b>Секция 8</b> – Аппаратурно методические аспекты синхротронных и нейтронных экспериментов</li>
        <li><b>Секция 9</b> – Теория, моделирование, вычислительные методы</li>
        <li><b>Секция 10</b> – Электронная, ионная и конфокальная микроскопия</li> -->
        <!-- <li><b>Секция 2</b> – Научные результаты, полученные на экспериментальных станциях Курчатовского комплекса синхротронно-нейтронных исследований</li>
        <li class="ml-5"><i>Подсекция 2.1</i> – Материаловедение</li>
        <li class="ml-5"><i>Подсекция 2.2</i> – Биология и науки о жизни</li>
        <li class="ml-5"><i>Подсекция 2.3</i> – Культурное наследие</li>
        <li><b>Секция 3</b> – Концепция и научная программа синхротронно-лазерного комплекса «СИЛА»</li>
        <li class="ml-5"><i>Подсекция 3.1</i> – Концептуальные проекты и научные программы экспериментальных станций первой очереди источника СИ</li>
        <li class="ml-5"><i>Подсекция 3.2</i> – Концептуальные проекты и научные программы экспериментальных станций первой очереди лазера на свободных электронах</li>
        <li><b>Микросимпозиум 1</b> – Разработка научной программы развития нейтронных исследований в Российской Федерации</li>
        <li><b>Микросимпозиум 2</b> – Научная программы проектов «РИФ» и ТНК «Зеленоград»</li>
        <li><b>Круглый стол</b> – Промышленное применение установок мегакласса</li>
        <li><b>Круглый стол</b> – Совместная подготовка кадров  для развития синхротронных и нейтронных исследований</li> -->
      </ul>

      <!-- <p class="mt-2">
        Также в рамках Совещания пользователей запланировано проведение <b>круглого стола</b> «Программа развития исследовательских возможностей Курчатовского комплекса синхротронно-нейтронных исследований»
      </p> -->
      <!-- <p class="mt-2">
        Также в рамках Курчатовского форума «Исследования с применением синхротронного излучения, нейтронов и электронов» пройдет
        <b>
          Школа: "Современные подходы к созданию детекторных материалов"
        </b>
      </p> -->
    </v-card>
  </div>
</template>
<script>

export default {
  name: 'Program',

  data() {
    return {
    }
  },

  methods: {
    openFile(fileName) {
      window.open(`https://api.kcsni-service.ru/media/static/Program_FSNE_26.pdf`, '_blank')
    },
  }

  

};
</script>

<style scoped>
.custom-list {
  list-style: none; 
  padding-left: 0;
}

.custom-list li {
  position: relative;
  padding-left: 24px;
  margin-bottom: 8px;
}

.custom-list li::before {
  content: "✓"; 
  position: absolute;
  left: 0;
  color: #185ba6;
  font-weight: bold;
}
</style>

<style lang="scss" scoped>
  hr{
    margin: 10px;
  }

  .prog-text{
    font-style: italic;
    color:rgb(4, 43, 75);
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
